module.exports = __webpack_public_path__ + "static/media/hibiki-icon.78e89eb1.png";